import {useEffect, useState} from 'react'
import {
  useHeaderBreadcrumb,
  useSelectDeviceId,
  useSelectInputSectionValue,
  useSelectInputSectionValueType,
} from '../../_metronic/layout/core'
import {Link, useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import {
  getListContentByCategoryId,
  getListExperimentByCategoryId,
  homeListCategoryTree,
} from '../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {useLang} from '../../_metronic/i18n/Metronici18n'
import ExperimentItem from './ExperimentItem'
import ContentScromModal from './Components/ContentScromModal'
import MultimediaContentItem from './Components/MultimediaContentItem'
import DigitalExperimentItem from './Components/DigitalExperimentItem'
import {useIntl} from 'react-intl'
import MultimediaContentModal from './Components/MultimediaContentModal'

interface Attribute {
  id: number
  circuitId: number
  key: string
  value: string
  dilCode: string
  description: string
}

interface Circuit {
  id: number
  experimentId: number
  code: string
  inputType: number
  ioType: number
  dilCode: string
  name: string
  description: string
  attiributeDTOs: Attribute[]
}

export interface Experiment {
  id: number
  code: string
  deviceCode: string
  dilCode: string
  name: string
  description: string
  circuitDTO: Circuit[]
  createdUserId: number
  createDate: string
  updateDate: string
  deleteDate: string | null
  isActive: boolean
  isDelete: boolean
}

interface SelectContentType {
  id?: number
  parentId?: number
}

function SelectContent({id, parentId}: SelectContentType) {
  const {state} = useLocation()
  const lang = useLang()
  const intl = useIntl()
  const {setChangeTitle, setChangeBeforeTitle, setReturnPath} = useHeaderBreadcrumb()
  const {SelectDeviceId} = useSelectDeviceId()

  const location = useLocation()
  useEffect(() => {
    let searchParamS = location.search.replace('?', '')
    if (searchParamS) {
      setSelectServices(Number(searchParamS))
    }
  }, [location])

  const {returnPath}: any = state || {}
  const selectCategoryId = id || Number(window.localStorage.getItem('categoryId'))

  const [lesson, setLesson] = useState<any>([])
  const [selectSerives, setSelectServices] = useState<number>(2)
  const [content, setContent] = useState([])
  const [experiment, setExperiment] = useState<Experiment[]>([])
  const [experimentList, setExperimentList] = useState([])
  const [selectItem, setSelectItem] = useState<any>([])
  const [selectMultimediaItem, setSelectMultimediaItem] = useState<any>([])
  const [progress, setProgress] = useState(0)

  const getList = async () => {
    try {
      const {data} = await homeListCategoryTree(true, Number(parentId), 0, '', lang, '', '')
      setLesson(data[0])
    } catch (error) {
      console.error(error)
    }
  }

  const getContent = async () => {
    try {
      const {data} = await getListContentByCategoryId(selectCategoryId, lang)
      setContent(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
      setContent([])
    }
  }

  const getExperiment = async () => {
    try {
      if (SelectDeviceId.length > 0) {
        const {data} = await getListExperimentByCategoryId(
          selectCategoryId,
          lang,
          SelectDeviceId || []
        )
        setExperiment(data)
      }
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
      setExperiment([])
    }
  }

  useEffect(() => {
    getList()
    getExperiment()
    getContent()
    //getExperimentList()
  }, [selectCategoryId, id, SelectDeviceId])

  useEffect(() => {
    setChangeTitle(
      lesson?.subList?.filter((item: any) => item.id === selectCategoryId)[0].nodeAd || ''
    )
    setChangeBeforeTitle(lesson?.nodeAd || '')
    setReturnPath(returnPath || '')
  }, [lesson])

  /*  const getExperimentList = async () => {
    try {
      const {data} = await homeListExperiment(0, '', '', lang, '')
      setExperimentList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }*/

  function countInputTypeThree(experiment: any) {
    let count = 0
    for (const item of experiment) {
      for (const circuitItem of item.circuitDTO) {
        if (circuitItem.inputType === 1) {
          count++
        }
      }
    }
    return count
  }

  const servicesList = [
    {
      id: 4,
      text: intl.formatMessage({id: 'UNITSPAGE.ENGAGE'}),
      icon: 'ki-outline ki-security-check',
    },
    {id: 5, text: intl.formatMessage({id: 'UNITSPAGE.EXPLORE'}), icon: 'ki-outline ki-abstract-28'},
    {
      id: 6,
      text: intl.formatMessage({id: 'UNITSPAGE.EXPLAIN'}),
      icon: 'ki-outline ki-wifi-square',
    },
    {
      id: 7,
      text: intl.formatMessage({id: 'UNITSPAGE.ELABORATE'}),
      icon: 'ki-outline ki-wifi-square',
    },
    {
      id: 8,
      text: intl.formatMessage({id: 'UNITSPAGE.EVALUATE'}),
      icon: 'ki-outline ki-wifi-square',
    },
  ]

  const {setSelectInputSectionValue} = useSelectInputSectionValue()
  const {setSelectInputSectionValueType} = useSelectInputSectionValueType()

  useEffect(() => {
    const controlListData: any[][] = []
    const controlListDataType: any[] = []
    experiment.forEach((item: any) => {
      const circuitDTOCount = item.circuitDTO.length
      const circuitControlList = Array(circuitDTOCount).fill([])
      controlListData.push(circuitControlList)

      for (let circuitDTO of item.circuitDTO) {
        controlListDataType.push(circuitDTO.inputType)
      }
    })
    setSelectInputSectionValueType(controlListDataType)
    setSelectInputSectionValue(controlListData)
  }, [experiment])

  return (
    <>
      {/* }
      <div className='toolbar py-2 px-0' id='kt_toolbar'>
        <div
          id='kt_toolbar_container'
          className={clsx(
            classes.toolbarContainer.join(' '),
            'd-flex align-items-center px-0 px-lg-8'
          )}
        >
          {config.pageTitle?.display && (
            <DefaultTitle
              changeBeforeTitle={lesson?.nodeAd || ''}
              stateData={lesson}
              returnPath={returnPath}
              changeTitle={
                lesson?.subList?.filter((item: any) => item.id === selectCategoryId)[0].nodeAd || ''
              }
            />
          )}
          <div className='flex-grow-1 flex-shrink-0 me-5'></div>
          <div className='d-flex align-items-center'>
            <Link
              //   to='/selectCategory/selectExperiment'
              // to='/selectCategory'
              to={'/' + returnPath}
              state={{path: returnPath}}
              className='btn btn-outline border-gray-600 btn-sm d-flex flex-center h-35px h-lg-40px'
            >
              Return<span className='d-none d-sm-inline ms-1'>Page</span>
            </Link>
          </div>
        </div>
      </div>
      {*/}
      <div
        id='kt_app_wrapper'
        className='app-wrapper row g-5 gx-xl-10 mt-md-n16 mt-2'
        style={
          {
            /*marginTop: -60*/
          }
        }
      >
        <div
          id='kt_app_sidebar2'
          className='app-sidebar flex-column card col-xl-3 rounded'
          //data-kt-drawer='true'
          data-kt-drawer-name='app-sidebar'
          data-kt-drawer-activate='{default: true, lg: false}'
          data-kt-drawer-overlay='true'
          data-kt-drawer-width='275px'
          data-kt-drawer-direction='start'
          data-kt-drawer-toggle='#kt_app_sidebar_toggle2'
        >
          <div className='flex-column-fluid px-4 py-4' id='kt_app_sidebar_nav'>
            <div
              //  id='kt_app_sidebar_nav_wrapper'
              className='d-flex flex-column h-md-100'
              // data-kt-scroll='true'
              // data-kt-scroll-activate='true'
              // data-kt-scroll-height='auto'
              // data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
              //  data-kt-scroll-wrappers='#kt_app_sidebar, #kt_app_sidebar_nav'
              //  data-kt-scroll-offset='5px'
              // style={{height: 647}}
            >
              <div className='symbol symbol-50px w-50px border'>
                <img
                  src={toAbsoluteUrl('/media/logos/data-science.png')}
                  alt='image'
                  className='p-1'
                />
              </div>
              <div className='d-flex align-items-center flex-column w-100 mb-6'>
                <div className='d-flex justify-content-between fw-bolder fs-6 text-gray-800  w-100 mt-auto mb-3'>
                  <h3 className='text-gray-800 fw-bold mt-2'>
                    {lesson?.subList?.filter((item: any) => item.id === selectCategoryId)[0].nodeAd}
                  </h3>
                </div>

                <div className='w-100 bg-light-primary rounded mb-2' style={{height: 24}}>
                  <div
                    className='bg-primary rounded'
                    role='progressbar'
                    style={{height: 24, width: `${progress}%`}}
                  />
                </div>

                <div className='fw-semibold fs-7 text-primary w-100 mt-auto'>
                  {/* 👇 Completed  👇 */}
                  <span>
                    %{progress} {intl.formatMessage({id: 'UNITSPAGE.COMPLETED'})}
                  </span>
                  {/* 👆 Completed  👆 */}
                </div>
              </div>

              <div className=' mb-6'>
                {/* 👇 Learning Models  👇 */}
                <h3 className='text-gray-800 fw-bold mb-8'>
                  {intl.formatMessage({id: 'UNITSPAGE.LEARNINGMODELS'})}
                </h3>
                {/* 👆 Learning Models  👆 */}
                <div
                  className='d-flex flex-stratch flex-wrap'
                  data-kt-buttons='true'
                  data-kt-buttons-target='[data-kt-button]'
                  data-kt-initialized='1'
                >
                  {/* 👇 Learning Model Butonları 👇 */}
                  {servicesList.map((item: any, index: any) => {
                    return (
                      <div key={index} className='mx-2 mb-4'>
                        <Link
                          className={`btn btn-icon btn-outline ${
                            selectSerives === item.id
                              ? 'btn-bg-primary'
                              : 'btn-bg-light btn-active-light-primary'
                          }  btn-flex flex-column flex-center w-lg-95px h-lg-95px w-70px h-70px border-gray-200`}
                          data-kt-button='true'
                          //  onClick={() => setSelectServices(item.id)}
                          to={`?${item.id}`}
                        >
                          <span className='mb-2'>
                            <i
                              className={`${item.icon} fs-1 ${
                                selectSerives === item.id ? 'text-white' : ''
                              }`}
                            />
                          </span>

                          <span
                            className={`fs-7 fw-bold  ${
                              selectSerives === item.id ? 'text-white' : ''
                            }`}
                          >
                            {item.text}
                          </span>
                        </Link>
                      </div>
                    )
                  })}

                  <div className='mx-2 mb-4'>
                    <Link
                      //onClick={() => setSelectServices(2)}
                      to={`?2`}
                      className={`btn btn-icon btn-outline ${
                        selectSerives === 2
                          ? 'btn-bg-primary'
                          : 'btn-bg-light btn-active-light-primary'
                      }  btn-flex flex-column flex-center w-lg-95px h-lg-95px w-70px h-70px border-gray-200`}
                      data-kt-button='true'
                    >
                      <span className='mb-2'>
                        <i
                          className={`ki-outline ki-technology fs-1 ${
                            selectSerives === 2 ? 'text-white' : ''
                          }`}
                        />
                      </span>
                      {/* 👇   Physical Experiment 👇 */}
                      <span className={`fs-7 fw-bold ${selectSerives === 2 ? 'text-white' : ''}`}>
                        {intl.formatMessage({id: 'UNITSPAGE.PHYSICALEXPERIMENT'})}
                      </span>
                      {/* 👆   Physical Experiment  👆 */}
                    </Link>
                  </div>
                  {/* 👆 Learning Model Butonları 👆 */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='app-main flex-column flex-row-fluid col-xl-3'>
          <div className='card-body flex-column p-5 card w-100 h-100 rounded col-xl-8 col-12 lesson-content sal-animate'>
            {/* 👇   Engage 👇 */}
            {selectSerives === 4 && (
              <>
                <div className='row g-5 gx-xl-10'>
                  <h3 className='mb-5'>{intl.formatMessage({id: 'UNITSPAGE.ENGAGE'})}</h3>

                  {content.map((item: any, index: number) => {
                    if (item.contentType === 4) {
                      if (item.file === null) {
                        return (
                          <MultimediaCard
                            key={index}
                            item={item}
                            setSelectMultimediaItem={setSelectMultimediaItem}
                          />
                        )
                      } else {
                        return (
                          <div key={index} className='col-xl-4 col-md-2 col-12 sal-animate'>
                            <div className='card border border-hover-primary  min-h-125px px-5 h-100'>
                              <div className='card-header pt-5 px-5 d-flex align-items-start border-0'>
                                <div className='symbol symbol-75px mb-5'>
                                  <img
                                    src={toAbsoluteUrl('/media/logos/lesson.png')}
                                    alt='image'
                                    className='p-1'
                                  />
                                </div>
                                <div className='card-toolbar'>
                                  <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#contentScrom_modal'
                                    onClick={() => setSelectItem(item)}
                                  >
                                    View Content
                                  </button>
                                </div>
                              </div>
                              <div className='card-body d-flex  flex-column px-5 pt-0'>
                                <span className='fs-4 text-gray-800  fw-bold mb-0'>
                                  {item?.contentTitle}
                                </span>
                                <div className='fw-semibold text-gray-400'>
                                  <div className='card-body d-flex flex-column px-0 pt-1'>
                                    <div className='fw-semibold text-gray-400 '>
                                      <div dangerouslySetInnerHTML={{__html: item?.spot}} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    }
                    return null
                  })}
                </div>
              </>
            )}
            {/* 👆   Engage  👆 */}

            {/* 👇   Explore 👇 */}
            {selectSerives === 5 && (
              <>
                <div className='row g-5 gx-xl-10'>
                  <h3 className='mb-5'>{intl.formatMessage({id: 'UNITSPAGE.EXPLORE'})}</h3>
                  {content.map((item: any, index: number) => {
                    if (item.contentType === 5) {
                      if (item.file === null) {
                        return (
                          <MultimediaCard
                            key={index}
                            item={item}
                            setSelectMultimediaItem={setSelectMultimediaItem}
                          />
                        )
                      } else {
                        return (
                          <div key={index} className='col-xl-4 col-md-2 col-12 sal-animate'>
                            <div className='card border border-hover-primary  min-h-125px px-5 h-100'>
                              <div className='card-header pt-5 px-5 d-flex align-items-start border-0'>
                                <div className='symbol symbol-75px mb-5'>
                                  <img
                                    src={toAbsoluteUrl('/media/logos/lesson.png')}
                                    alt='image'
                                    className='p-1'
                                  />
                                </div>
                                <div className='card-toolbar'>
                                  <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#contentScrom_modal'
                                    onClick={() => setSelectItem(item)}
                                  >
                                    View Content
                                  </button>
                                </div>
                              </div>
                              <div className='card-body d-flex  flex-column px-5 pt-0'>
                                <span className='fs-4 text-gray-800  fw-bold mb-0'>
                                  {item?.contentTitle}
                                </span>
                                <div className='fw-semibold text-gray-400'>
                                  <div className='card-body d-flex flex-column px-0 pt-1'>
                                    <div className='fw-semibold text-gray-400 '>
                                      <div dangerouslySetInnerHTML={{__html: item?.spot}} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    }
                    return null
                  })}
                </div>
              </>
            )}
            {/* 👆   Explore  👆 */}

            {/* 👇   Explain 👇 */}
            {selectSerives === 6 && (
              <>
                <div className='row g-5 gx-xl-10'>
                  <h3 className='mb-5'>{intl.formatMessage({id: 'UNITSPAGE.EXPLAIN'})}</h3>
                  {content.map((item: any, index: number) => {
                    if (item.contentType === 6) {
                      if (item.file === null) {
                        return (
                          <MultimediaCard
                            key={index}
                            item={item}
                            setSelectMultimediaItem={setSelectMultimediaItem}
                          />
                        )
                      } else {
                        return (
                          <div key={index} className='col-xl-4 col-md-2 col-12 sal-animate'>
                            <div className='card border border-hover-primary  min-h-125px px-5 h-100'>
                              <div className='card-header pt-5 px-5 d-flex align-items-start border-0'>
                                <div className='symbol symbol-75px mb-5'>
                                  <img
                                    src={toAbsoluteUrl('/media/logos/lesson.png')}
                                    alt='image'
                                    className='p-1'
                                  />
                                </div>
                                <div className='card-toolbar'>
                                  <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#contentScrom_modal'
                                    onClick={() => setSelectItem(item)}
                                  >
                                    View Content
                                  </button>
                                </div>
                              </div>
                              <div className='card-body d-flex  flex-column px-5 pt-0'>
                                <span className='fs-4 text-gray-800  fw-bold mb-0'>
                                  {item?.contentTitle}
                                </span>
                                <div className='fw-semibold text-gray-400'>
                                  <div className='card-body d-flex flex-column px-0 pt-1'>
                                    <div className='fw-semibold text-gray-400 '>
                                      <div dangerouslySetInnerHTML={{__html: item?.spot}} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    }

                    return null
                  })}
                </div>
              </>
            )}
            {/* 👆   Explain  👆 */}

            {/* 👇   Elaborate 👇 */}
            {selectSerives === 7 && (
              <>
                <div className='row g-5 gx-xl-10'>
                  <h3 className='mb-5'>{intl.formatMessage({id: 'UNITSPAGE.ELABORATE'})}</h3>
                  {content.map((item: any, index: number) => {
                    if (item.contentType === 7) {
                      if (item.file === null) {
                        return (
                          <MultimediaCard
                            key={index}
                            item={item}
                            setSelectMultimediaItem={setSelectMultimediaItem}
                          />
                        )
                      } else {
                        return (
                          <div key={index} className='col-xl-4 col-md-2 col-12 sal-animate'>
                            <div className='card border border-hover-primary  min-h-125px px-5 h-100'>
                              <div className='card-header pt-5 px-5 d-flex align-items-start border-0'>
                                <div className='symbol symbol-75px mb-5'>
                                  <img
                                    src={toAbsoluteUrl('/media/logos/lesson.png')}
                                    alt='image'
                                    className='p-1'
                                  />
                                </div>
                                <div className='card-toolbar'>
                                  <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#contentScrom_modal'
                                    onClick={() => setSelectItem(item)}
                                  >
                                    View Content
                                  </button>
                                </div>
                              </div>
                              <div className='card-body d-flex  flex-column px-5 pt-0'>
                                <span className='fs-4 text-gray-800  fw-bold mb-0'>
                                  {item?.contentTitle}
                                </span>
                                <div className='fw-semibold text-gray-400'>
                                  <div className='card-body d-flex flex-column px-0 pt-1'>
                                    <div className='fw-semibold text-gray-400 '>
                                      <div dangerouslySetInnerHTML={{__html: item?.spot}} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    }
                    return null
                  })}
                </div>
              </>
            )}
            {/* 👆   Elaborate  👆 */}

            {/* 👇   Evaluate 👇 */}
            {selectSerives === 8 && (
              <>
                <div className='row g-5 gx-xl-10'>
                  <h3 className='mb-5'>{intl.formatMessage({id: 'UNITSPAGE.EVALUATE'})}</h3>

                  {content.map((item: any, index: number) => {
                    if (item.contentType === 8) {
                      if (item.file === null) {
                        return <DigitalExperimentItem index={index} item={item} />
                      } else {
                        return (
                          <div key={index} className='col-xl-4 col-md-2 col-12 sal-animate'>
                            <div className='card border border-hover-primary  min-h-125px px-5 h-100'>
                              <div className='card-header pt-5 px-5 d-flex align-items-start border-0'>
                                <div className='symbol symbol-75px mb-5'>
                                  <img
                                    src={toAbsoluteUrl('/media/logos/lesson.png')}
                                    alt='image'
                                    className='p-1'
                                  />
                                </div>
                                <div className='card-toolbar'>
                                  <button
                                    type='button'
                                    className='btn btn-primary'
                                    data-bs-toggle='modal'
                                    data-bs-target='#contentScrom_modal'
                                    onClick={() => setSelectItem(item)}
                                  >
                                    View Content
                                  </button>
                                </div>
                              </div>
                              <div className='card-body d-flex  flex-column px-5 pt-0'>
                                <span className='fs-4 text-gray-800  fw-bold mb-0'>
                                  {item?.contentTitle}
                                </span>
                                <div className='fw-semibold text-gray-400'>
                                  <div className='card-body d-flex flex-column px-0 pt-1'>
                                    <div className='fw-semibold text-gray-400 '>
                                      <div dangerouslySetInnerHTML={{__html: item?.spot}} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    }
                    return null
                  })}
                </div>
              </>
            )}
            {/* 👆   Evaluate  👆 */}

            {/* 👇   Physical Experiment 👇 */}
            {selectSerives === 2 && (
              <>
                <h3 className='mb-4'>{intl.formatMessage({id: 'UNITSPAGE.PHYSICALEXPERIMENT'})}</h3>
                <ExperimentItem
                  experiment={experiment}
                  //  experimentList={experimentList}
                  countButton={countInputTypeThree(experiment)}
                />
              </>
            )}
            {/* 👆   Physical Experiment  👆 */}
          </div>
        </div>
      </div>
      {/* */}
      <ContentScromModal item={selectItem} />
      <MultimediaContentModal item={selectMultimediaItem} />
      {/* */}
    </>
  )
}

export default SelectContent

const MultimediaCard = ({item, setSelectMultimediaItem}) => {
  return (
    <div className='col-xl-4 col-md-2 col-12 sal-animate'>
      <div className='card border border-hover-primary  min-h-125px px-5 h-100'>
        <div className='card-header pt-5 px-5 d-flex align-items-start border-0'>
          <div className='symbol symbol-75px mb-5'>
            <img src={toAbsoluteUrl('/media/logos/lesson.png')} alt='image' className='p-1' />
          </div>
          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-primary'
              data-bs-toggle='modal'
              data-bs-target='#multimediaContent_modal'
              onClick={() => setSelectMultimediaItem(item)}
            >
              View Content
            </button>
          </div>
        </div>
        <div className='card-body d-flex  flex-column px-5 pt-0'>
          <span className='fs-4 text-gray-800  fw-bold mb-0'>{item?.contentTitle}</span>
          <div className='fw-semibold text-gray-400'>
            <div className='card-body d-flex flex-column px-0 pt-1'>
              <div className='fw-semibold text-gray-400 '>
                <div dangerouslySetInnerHTML={{__html: item?.spot}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
